import { render, staticRenderFns } from "./FailureReasons.vue?vue&type=template&id=b6c686bc"
import script from "./FailureReasons.vue?vue&type=script&lang=js"
export * from "./FailureReasons.vue?vue&type=script&lang=js"
import style0 from "./FailureReasons.vue?vue&type=style&index=0&id=b6c686bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports